export const MatchStates: Record<number, string> = {
  1: "NS",
  2: "INPLAY_1ST_HALF",
  3: "HT",
  4: "BREAK",
  5: "FT",
  6: "INPLAY_ET",
  7: "AET",
  8: "FT_PEN",
  9: "INPLAY_PENALTIES",
  10: "POSTPONED",
  11: "SUSPENDED",
  12: "CANCELLED",
  13: "TBA",
  14: "WO",
  15: "ABANDONED",
  16: "DELAYED",
  17: "AWARDED",
  18: "INTERRUPTED",
  19: "AWAITING_UPDATES",
  20: "DELETED",
  21: "EXTRA_TIME_BREAK",
  22: "INPLAY_2ND_HALF",
  23: "INPLAY_ET_2ND_HALF",
  25: "PEN_BREAK",
  26: "PENDING"
};
